import { render, staticRenderFns } from "./BookmarkIcon.vue?vue&type=template&id=6cc84d9a"
import script from "./BookmarkIcon.vue?vue&type=script&lang=ts"
export * from "./BookmarkIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc84d9a')) {
      api.createRecord('6cc84d9a', component.options)
    } else {
      api.reload('6cc84d9a', component.options)
    }
    module.hot.accept("./BookmarkIcon.vue?vue&type=template&id=6cc84d9a", function () {
      api.rerender('6cc84d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/BookmarkIcon.vue"
export default component.exports